import { render, staticRenderFns } from "./ForbiddenKeywordsPopup.vue?vue&type=template&id=c7ad7a24&scoped=true"
import script from "./ForbiddenKeywordsPopup.vue?vue&type=script&lang=js"
export * from "./ForbiddenKeywordsPopup.vue?vue&type=script&lang=js"
import style0 from "./ForbiddenKeywordsPopup.vue?vue&type=style&index=0&id=c7ad7a24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ad7a24",
  null
  
)

export default component.exports